import React from 'react';
import PropTypes from 'prop-types';
import { FlexColumn, FlexRow } from 'web-ui-components/lib/global/layout';
import { connect } from 'react-redux';
import withContent from '../../../../containers/withContent';
import { getBacsDetailsWithAccounts } from '../../../../states/bacsDebit/selectors';
import { fixAmount } from '../../../../helpers/fieldHelpers';
import { formatSortCode } from '../../../../utils/accountUtils';
import bacsTableContent, { contentPropTypes } from '../BacsTable.content';
import BacsTable from '../BacsTable';

const mapState = (state) => ({
	bacsDetails: getBacsDetailsWithAccounts(state),
});

const DebitTable = ({
	bacsDetails,
	showTotal,
	content: { fromLabel, amountLabel, referenceLabel, transactionCodeLabel, totalAmountLabel },
}) => {
	const renderHeader = () => (
		<FlexRow>
			<FlexColumn>
				<strong>{fromLabel}</strong>
			</FlexColumn>
			<FlexColumn>
				<strong>{amountLabel}</strong>
			</FlexColumn>
			<FlexColumn>
				<strong>{referenceLabel}</strong>
			</FlexColumn>
			<FlexColumn>
				<strong>{transactionCodeLabel}</strong>
			</FlexColumn>
		</FlexRow>
	);

	const renderFooter = () => (
		<FlexRow>
			<FlexColumn>
				<strong>{totalAmountLabel}</strong>
			</FlexColumn>
			<FlexColumn>
				<strong>{`£${fixAmount(bacsDetails.total)}`} </strong>
			</FlexColumn>
			<FlexColumn />
			<FlexColumn />
		</FlexRow>
	);

	const renderBody = (payment) => {
		const {
			from: { displayName, accountNumber, sortCode },
			amount,
			reference,
			transactionCode,
		} = payment;
		return (
			<FlexRow>
				<FlexColumn>
					<div className="u-flex-align-items-center">
						{displayName && (
							<div>
								<span>{displayName}</span>
							</div>
						)}
						{accountNumber && (
							<div>
								<span>{`${formatSortCode(sortCode)} | ${accountNumber}`}</span>
							</div>
						)}
					</div>
				</FlexColumn>
				<FlexColumn>
					<div className="u-padding-top-2">{`£${fixAmount(amount)}`}</div>
				</FlexColumn>
				<FlexColumn>
					<div className="u-padding-top-2">{reference}</div>
				</FlexColumn>
				<FlexColumn>
					<div className="u-padding-top-2">{transactionCode}</div>
				</FlexColumn>
			</FlexRow>
		);
	};
	return (
		<BacsTable
			bacsDetails={bacsDetails}
			renderBody={renderBody}
			renderHeader={renderHeader}
			renderFooter={renderFooter}
			showFooter={showTotal}
		/>
	);
};

DebitTable.defaultProps = {
	showTotal: true,
};

DebitTable.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	showTotal: PropTypes.bool,
};

export const contentWrapper = withContent({ content: bacsTableContent })(DebitTable);
export default connect(mapState)(contentWrapper);
